import { boolean, defaulted, enums, nullable, object, optional, string, trimmed, unknown } from 'superstruct';
import { emptyStringIsNull } from '@arc/shared/util-superstruct';
import { FILTER_TYPES } from '../filter-types';
export const BaseFilter = object({
  name: trimmed(emptyStringIsNull(string())),
  originalName: defaulted(nullable(string()), () => null),
  filterType: enums(FILTER_TYPES),
  filterValues: unknown(),
  saved: boolean(),
  savedAll: boolean(),
  savedDefault: optional(boolean())
});

// The below is great but unfortunately does not work without version of superstruct
// TODO: Update this once we update superstruct!

// export const FilterFormDto = union([
// 	assign(
// 		BaseFilter,
// 		object({
// 			filterType: literal('interactions'),
// 			filterValues: InteractionsFilterValues,
// 		})
// 	),
// ]);

// export type FilterFormDto = Infer<typeof FilterFormDto>;